import { ALERT_STATUS_LABELS } from "src/constants/alerts";
import { useT } from "src/internationalization";
import { AlertStatus } from "src/types/alert";

export const useGetAlertStatusLabel = () => {
  const t = useT();

  const getAlertStatusLabel = (status: AlertStatus) => {
    return t(ALERT_STATUS_LABELS[status]);
  };

  return getAlertStatusLabel;
};
